// extracted by mini-css-extract-plugin
export default {"parentLetterHeader":"parentLetterHeader-eG7Ml","parentLetterLogo":"parentLetterLogo-NHlWp","parentLetterInfoBlock":"parentLetterInfoBlock-JQxyZ","teacherName":"teacherName-UcINJ"};